import { useEffect, useState } from "react";
import styles from "./contains_data_no_delete.module.css";

import { cloneDeep } from "lodash";
import { useLocation } from "react-router-dom";
import { Dialog, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

export default function ContainsDataNoDeleteModal(props) {
  const { isOpen, close, onYes, selectedFiles } = props;
  const [value, setValue] = useState("");

  return (
    <Dialog open={isOpen} onClose={close}>
      <div className={styles.modal_wrapper}>
        <div className={styles.modal_title}>{`Data or folders exist in:`}</div>
        <div className={styles.modal_body}>
          {selectedFiles.map((file) => (
            <div className={styles.name}>{file.name}</div>
          ))}
        </div>
        <div className={styles.modal_body}>Please empty this folder before deleting it.</div>
        <div className={styles.modal_button_wrapper}>
          <LoadingButton disabled={false} variant="contained" loading={false} onClick={close}>
            Okay
          </LoadingButton>
        </div>
      </div>
    </Dialog>
  );
}
